// 私有化构建会通过流水线修改此文件，请勿代码中修改提交！！！
import { isPrivate as isPrivateFromCommon } from 'src/common/qdAdminCommon';

// 是否是私有化环境
const isPrivate = false || isPrivateFromCommon;
// 是否有发短信能力
const smsAbility = true;

export { isPrivate, smsAbility };
